import { createAction, props } from '@ngrx/store';

import {
  IPipeline,
  IPipelinePagination,
  EPipelineActions,
} from '../models/pipeline.model';

export const loadPipelines = createAction(
  EPipelineActions.LOAD_PIPELINES,
  props<{ pagination: IPipelinePagination; activePagination? }>()
);

export const loadPipelinesSuccess = createAction(
  EPipelineActions.LOAD_PIPELINES_SUCCESS,
  props<{
    pipelines: IPipeline[];
    pagination: IPipelinePagination;
  }>()
);

export const loadPipelinesError = createAction(
  EPipelineActions.LOAD_PIPELINES_ERROR,
  props<{ error: any }>()
);

export const refreshPipelines = createAction(
  EPipelineActions.REFRESH_PIPELINES,
  props<{ pagination: IPipelinePagination }>()
);

export const createPipelines = createAction(
  EPipelineActions.CREATE_PIPELINES,
  props<{ pipeline: IPipeline }>()
);

export const createPipelinesSuccess = createAction(
  EPipelineActions.CREATE_PIPELINES_SUCCESS
);

export const createPipelinesError = createAction(
  EPipelineActions.CREATE_PIPELINES_ERROR,
  props<{ error: any }>()
);

export const updatePipelines = createAction(
  EPipelineActions.UPDATE_PIPELINES,
  props<{ pipeline: IPipeline }>()
);

export const updatePipelinesSuccess = createAction(
  EPipelineActions.UPDATE_PIPELINES_SUCCESS
);

export const updatePipelinesError = createAction(
  EPipelineActions.UPDATE_PIPELINES_ERROR,
  props<{ error: any }>()
);

export const deletePipelines = createAction(
  EPipelineActions.DELETE_PIPELINES,
  props<{ pipeline: IPipeline }>()
);

export const deletePipelinesSuccess = createAction(
  EPipelineActions.DELETE_PIPELINES_SUCCESS
);

export const deletePipelinesError = createAction(
  EPipelineActions.DELETE_PIPELINES_ERROR,
  props<{ error: any }>()
);
